exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".simulator-chart-range {\n  opacity: 0.3;\n}\n\n.simulator-chart-graphs {\n  margin-bottom: 25px;\n}\n\n.simulator-chart-graphs .highcharts-navigator{\n  fill: #53617e;\n  background: #53617e;\n}\n\n.simulator-chart-graphs .highcharts-container{\n  margin-left: 12px;\n}\n", ""]);

// exports
